import {Box, Stack, Button} from "@mui/material";
import RpIcon, {RpIconColor} from '@/components/RpIcon';
import { useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useErrorBoundary, withErrorBoundary} from "react-use-error-boundary";

const ErrorBoundary = withErrorBoundary(({children}) => {
  const [error, resetError] = useErrorBoundary(
    // log the error to an error reporting service
    // (error, errorInfo) => logErrorToMyService(error, errorInfo)
  );

  const {t} = useTranslation();

  if (error) {
    return (
      <Stack
        sx={{flex: 1, gap: '16px', justifyContent: 'center', alignItems: 'center'}}
        className='unsupport-wrapper'>
        <RpIcon icon={'close'} size={55} color={RpIconColor.ERROR}/>
        <div className="p-5">{t('something_error')}</div>
        <Button variant="contained"
          onClick={() => {
            window.location.href = '/'
          }}
        >{t('home')}</Button>
      </Stack>
    );

  }

  return <>{children}</>;
});

export default ErrorBoundary;
